import styled, { keyframes, css } from "styled-components";
import { scaleOnClickAnim, whiteBgOnClickAnim } from "../../animations";

const playBtnClick = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.65);
    animation-timing-function: (0.33, 0, 0, 1);
  }
`;
const cashoutBtnClick = keyframes`
  0% {
    transform: scale(0.65);
  }
  100% {
    transform: scale(1);
    animation-timing-function: (0.33, 0, 0, 1);
  }
`;

const balanceDisapear = keyframes` 
  0% {
    opacity: 1;
    pointer-events: auto;
    display: block;
  }
  99% {
    opacity: 0;
    pointer-events: auto;
    display: block;
  }
  100% {
    opacity: 0;
    display: none;
    pointer-events: none;
  }
`;

const balanceDisapearAnim = css`
  ${balanceDisapear}
`;
const playBtnClickAnim = css`
  ${playBtnClick}
`;
const cashoutBtnClickAnim = css`
  ${cashoutBtnClick}
`;
export const FooterContainer = styled.div`
  color: #ff3920;
  font-size: 20px;
  pointer-events: ${(p) => (p.disabled ? "none" : "auto")};
  @media only screen and (min-width: 375px) {
    font-size: 20px;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  :first-child {
    margin-bottom: 18px;
  }
`;

export const BalanceBtn = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap-reverse;
  font-size: 12px;
  color: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  padding:  5px;
  z-index: 0;
  height: 56px;
  width: 53.473%;
  max-width: 178px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  align-items: center;
  justify-content: center;
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) => (p.setbet ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
  p {
    display: contents;
    width: 100%;
    line-height: 1;
    svg {
      /* height: 20px;
      width: 20px; */
      margin-left: 4px;
      path {
        fill: #ffb000;
      }
    }
  }
  ${(p) =>
    p.gameIsOn
      ? "position: absolute; right: 50%; transform: translateX(50%);"
      : "position: relative; right: unset; transform: translateX(0)"};
  animation: ${(p) => (p.gameIsOn ? balanceDisapearAnim : null)};
  animation-duration: 0.167s;
  animation-fill-mode: forwards;

  @media only screen and (min-width: 375px) {
    height: 56px;
    max-width: 178px;
    font-size: 12px;
  }
`;

export const MainBtn = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  /* height: 46px; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  /* font-size: 16px; */
  height: 56px;
  font-size: 20px;
  cursor: pointer;
  animation: ${(p) =>
    p.playBtn
      ? playBtnClickAnim
      : !p.cashoutBtn && p.gameIsOn
      ? cashoutBtnClickAnim
      : p.cashoutBtn
      ? playBtnClickAnim
      : !p.gameIsOn && !p.playBtn
      ? cashoutBtnClickAnim
      : null};
  animation-duration: 0.167s;
  animation-fill-mode: forwards;
  position: relative;
  ${(p) =>
    p.cashout && p.gameIsOn
      ? "border-color: #ffb000; color: #ffb000; background: transparent; path{fill: #ffb000;}"
      : !p.cashout && p.gameIsOn
      ? "border-color: #483b3b; color: #483b3b; background: transparent; path{fill: #483b3b;}"
      : "border-color: #ffb000; color: #ff3920; background: #ffb000; path{fill: #ffb000;}"};
  transition: all 0.25s;
  transition-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
  pointer-events: ${(p) => (p.disabled || p.playBtn ? "none" : "auto")};
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) => (p.playBtn ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
  span {
    /* font-size: 10px; */
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${(p) => (p.gameIsOn ? "display: flex;" : "display: none")};
    svg {
      /* width: 20px;
      height: 20px; */
      margin-left: 4px;
      path {
        ${(p) =>
          p.cashout && p.gameIsOn
            ? "fill: #ffb000;"
            : !p.cashout && p.gameIsOn
            ? "fill: #483b3b;"
            : "fill: #ffb000;"};
        transition: all 0.25s;
        transition-timing-function: cubic-bezier(0.17, 0.17, 0, 1);
      }
    }
  }
  p:first-child {
  display: contents;
    ${(p) => (p.gameIsOn ? "display:none;" : "display: block")};
  }
  p:nth-child(2) {
    ${(p) => (p.gameIsOn ? "display: block;" : "display: none")};
  }
  @media only screen and (min-width: 375px) {
    height: 56px;
    font-size: 20px;
    span {
      font-size: 12px;
    }
  }
`;
export const OperationBtn = styled.div`
  /* height: 46px;
  width: 46px; */
  height: 56px;
  width: 56px;
  background: #ffb000;
  /* border: solid 3px; */
  /* border-color: #ffb000; */
  color: #ff3920;
  border-radius: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  animation: ${(p) =>
    p.divide || p.double
      ? scaleOnClickAnim
      : p.loBtnAnim || p.hiBtnAnim
      ? playBtnClickAnim
      : cashoutBtnClickAnim};
  animation-duration: ${(p) => (p.divide || p.double ? "0.333s" : "0.167s")};
  animation-fill-mode: forwards;
  overflow: hidden;
  z-index: 1;
  ${(p) =>
    p.gameIsOn
      ? "width: 47% !important; transition: width 0.333s; transition-timing-function: cubic-bezier(0.17, -0.17, 0, 1);"
      : null};
  transition: width 0.333s;
  transition-timing-function: cubic-bezier(0.17, -0.17, 0, 1);
  pointer-events: ${(p) => (p.disabled ? "none" : "auto")};

  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) => (p.divide || p.double ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1;
    p {
      line-height: 0.8;
    }
  }
  svg {
    /* width: 28px; */
    width: 32px;

  }
  @media only screen and (min-width: 375px) {
    height: 56px;
    width: 56px;
    svg {
      width: 32px;
    }
  }
`;
export const GamePlayContainer = styled.div`
  max-width: 285px;
  margin: auto;
`;
